/**
 * The composers' strip (slice 1j §6.1, §6.1a): an update in progress, or
 * asks refused though the AI has worked before, with the owner's way there.
 */
import type { ComposerNotice } from "@crew/ui/components/composer";
import { TextLink } from "@crew/ui/components/typography";
import type { AskGate } from "./api";

/** Slice 1j §7: the update's strip, and the locked one. */
const UPDATING_NOTICE =
  "Your crew workspace is being updated. You can keep working: your messages are queued until it's ready.";
const LOCKED_NOTICE = "Your crew workspace is not connected yet. Retry once it's connected again.";

/** The composer's strip for the gate, or null (slice 1j §6.1, §6.1a). */
export function gateNotice(gate: AskGate): ComposerNotice | null {
  if (gate.notice === "updating") return { tone: "updating", text: UPDATING_NOTICE };
  if (gate.notice !== "locked") return null;
  if (!gate.href) return { tone: "locked", text: LOCKED_NOTICE };
  return {
    tone: "locked",
    text: (
      <>
        {LOCKED_NOTICE} <TextLink href={gate.href}>Settings → AI</TextLink>
      </>
    ),
  };
}
